'use client';

import React, { useState } from "react";
import { P } from "@/components/ui/P";
import { Htag } from "@/components/ui/htag";
import { ChevronDown, ChevronUp } from "lucide-react";

const items = [
    {
        id: 1,
        title: 'Оставьте заявку или звоните нам',
        description: 'Вы получите подробную консультацию, наши специалисты ответят на ваши вопросы и помогут выбрать подходящую услугу.',
        description2: 'Наши эксперты подробно объяснят все этапы процесса и предложат наиболее эффективные решения, исходя из ваших потребностей.',
    },
    {
        id: 2,
        title: 'Мы анализируем вашу ситуацию',
        description: 'Анализ включает оценку рыночной стоимости недвижимости и юридическую проверку документов.',
        description2: 'Мы учитываем все ваши пожелания и требования, чтобы предложить наиболее выгодные и подходящие варианты.',
    },
    {
        id: 3,
        title: 'Заключение договора купли-продажи',
        description: 'Мы подготовим договор купли-продажи с учётом всех ваших пожеланий.',
        description2: 'Наши юристы обеспечивают полное сопровождение сделки, даже если на недвижимости есть долги или аресты.',
    },
    {
        id: 4,
        title: 'Взаиморасчеты',
        description: 'После подписания договора вы получаете деньги за недвижимость.',
        description2: 'Мы гарантируем надёжность, прозрачность и своевременность всех расчётов.',
    }
];

export default function Stages() {
    const [openItems, setOpenItems] = useState(new Array(items.length).fill(false));

    const toggleItem = (index: number) => {
        const updated = [...openItems];
        updated[index] = !updated[index];
        setOpenItems(updated);
    };

    return (
        <section className="my-16 px-6">
            <P size="l" className="mb-12 text-gray-400 font-semibold ml-6 lg:ml-7">Как мы работаем</P>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                {items.map((item, index) => (
                    <div
                        key={item.id}
                        className="relative bg-white border border-gray-200 rounded-3xl p-6 shadow-md hover:shadow-lg transition duration-300"
                    >
                        {/* Step number */}
                        <div className="absolute -top-5 left-4 bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md">
                            {index + 1}
                        </div>

                        {/* Title */}
                        <Htag tag="h3" className="text-xl font-semibold text-gray-900 mt-6 mb-3">
                            {item.title}
                        </Htag>

                        <div className="h-[2px] w-16 bg-primary rounded-full mb-4" />

                        {/* Main description */}
                        <P className="text-gray-700" size={'s'}>{item.description}</P>

                        {/* Expandable details */}
                        <div
                            className={`transition-all duration-300 overflow-hidden ${
                                openItems[index] ? 'max-h-40 mt-3 opacity-100' : 'max-h-0 opacity-0'
                            }`}
                        >
                            <P className="text-gray-600" size={'s'}>{item.description2}</P>
                        </div>

                        {/* Toggle button */}
                        <button
                            onClick={() => toggleItem(index)}
                            className="mt-5 flex items-center text-sm text-primary font-medium hover:underline transition"
                        >
                            {openItems[index] ? (
                                <>
                                    Скрыть <ChevronUp size={16} className="ml-1" />
                                </>
                            ) : (
                                <>
                                    Подробнее <ChevronDown size={16} className="ml-1" />
                                </>
                            )}
                        </button>
                    </div>
                ))}
            </div>
        </section>
    );
}
